<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <rednax-datatable
                :columns="table_columns"
                :filter="table_filter"
                @updateFilter="table_filter=$event"
                url="/vue/economy/report/adyen-settlement"
                @rowclick="rowClick"
                sort-by="id"
                sort-order="desc"
            >
                <div class="custom-control custom-checkbox mb-2">
                    <input type="checkbox" class="custom-control-input" id="cc_ls_c" v-model="table_filter.showall" true-value="false" false-value="true">
                    <label class="custom-control-label" for="cc_ls_c">Visa även godkända och överförda</label>
                </div>
                <template #cell_payout_row_ref="{ row }">
                    <div
                        v-for="(payout_row, pr_index) in getPayoutRows(row)"
                        :key="'pr_ref-' + row.id + '-' + pr_index"
                    >
                        {{ payout_row.modification_reference }} ({{ payout_row.net_currency }})
                    </div>
                </template>
                <template #cell_payout_row_date="{ row }">
                    <div
                        v-for="(payout_row, pr_index) in getPayoutRows(row)"
                        :key="'pr_date-' + row.id + '-' + pr_index"
                    >
                        {{ payout_row.creation_date }} ({{ payout_row.net_currency }})
                    </div>
                </template>
                <template #cell_dates="{ row }">
                    {{ row.from_date }} - {{ row.to_date }}
                </template>
                <template #cell_approved_at="{ row }">
                    <div v-if="row.approved_at">
                        <span class="text-success" :id="'tooltip-approved-target-' + row.id"><i class="icon-checkmark4"></i></span>
                        <b-tooltip :target="'tooltip-approved-target-' + row.id" triggers="hover">
                            {{ row.approved_at }}
                        </b-tooltip>
                    </div>
                </template>
                <template #cell_fortnox_id="{ row }">
                    <div v-if="row.fortnox_id">
                        <span class="text-success" :id="'tooltip-target-' + row.id"><i class="icon-checkmark4"></i></span>
                        <b-tooltip :target="'tooltip-target-' + row.id" triggers="hover">
                            {{ row.fortnox_id }}
                        </b-tooltip>
                    </div>
                    <div v-else-if="row.fortnox_error">
                        <span class="text-red" :id="'tooltip-target-' + row.id"><i class="icon-alert"></i></span>
                        <b-tooltip :target="'tooltip-target-' + row.id" triggers="hover">
                            {{ row.fortnox_error }}
                        </b-tooltip>
                    </div>
                </template>
            </rednax-datatable>
        </div>
    </div>
</template>

<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';

export default {
    metaInfo() {
        return {
            title: this.$route.meta.name,
        };
    },
    components: {
        RednaxDatatable,
        LimitlessPageHeader,
    },
    data: () => ({
        table_filter: {
            showall: true,
        },
        table_columns: [
            {
                header: '#',
                data: 'id',
                sortable: true,
            },
            {
                header: 'Utbetalningsdatum',
                data: 'payout_row_date',
                sortable: false,
            },
            {
                header: 'Referens',
                data: 'payout_row_ref',
                sortable: false,
            },
            {
                header: 'Filename',
                data: 'filename',
                sortable: true,
            },
            {
                header: 'Avser',
                data: 'dates',
                sortable: false,
            },
            {
                header: 'Godkänd',
                data: 'approved_at',
                sortable: true,
            },
            {
                header: 'Fortnox',
                data: 'fortnox_id',
                sortable: true,
            },
        ],
    }),
    methods: {
        rowClick(row) {
            this.$router.push({ name: 'economy.report.adyen-settlement-report.view', params: { id: row.id } });
        },
        getPayoutRows(row) {
            return row.rows.filter((reportRow) => reportRow.type === 'MerchantPayout');
        },
    },
};
</script>
